import './App.css';
import { HashRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import Home from './Home';
import About from './About'
import PrivacyPolicy from './PrivacyPolicy';
import AccountDelete from './AccountDelete';
import Login from './Login';
import ChangePassword from './ChangePassword';
import NewRequest from './User Dashboard/NewRequest';
import HeadAndSide from './User Dashboard/HeadAndSide';
import AuthenticationForLogin from './User Dashboard/AuthenticationForLogin';
import RequestManagement from './User Dashboard/RequestManagement';
import Bookings from './User Dashboard/Bookings';
import AddCarousel from './User Dashboard/AddCarousel';
import Requests from './User Dashboard/Requests';
import HelpAndSupport from './User Dashboard/HelpAndSuppport';
import UserAllQuery from './User Dashboard/UserAllQuery';
import HelpReply from './User Dashboard/HelpReply';
import HomeLayoute from './HomeLayoute';
import SaveCabs from './User Dashboard/SaveCabs';
import UserTrips from './User Dashboard/UserTrips';
import TripDetails from './User Dashboard/TripDetails';
import Header from './Header';
import ScrollToTop from './ScrollToTop';
import ConfigurationManagement from './User Dashboard/ConfigurationManagement';
import Dashboard from './User Dashboard/Dashboard';
import TermConditions from './User Dashboard/TermsConditions';
import RefundPolicy from './User Dashboard/RefundPolicy';
import ContactUs from './ContactUs';
import RegisterVendor from './User Dashboard/RegisterVendor';
import VendorForm from './User Dashboard/VendorForm';
import AddCab from './User Dashboard/AddCab';
import AddDriver from './User Dashboard/AddDriver';
import CabDetails from './User Dashboard/CabDetails';
import PlanManagement from './User Dashboard/PlanManagement';
import SMSCampaignManagement from './User Dashboard/SMSCampaignManagement';

// Function to check authentication
const isLoggedIn = () => !!localStorage.getItem("isLoggedIn");

// Protected route component
const ProtectedRoute = () => {
  return isLoggedIn() ? <Outlet /> : <Navigate to="/login" replace />;
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Public Routes */}

        <Route element={<HomeLayoute />}>
          <Route path="/" element={<Home />} />
          <Route path='/about' element={<About />} />
          <Route path='/contact-us' element={<ContactUs />} />
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/terms-conditions' element={<TermConditions />} />
          <Route path='/refund-policy' element={<RefundPolicy />} />
          <Route path='/delete-account' element={<AccountDelete />} />
        </Route>
        <Route path="/login" element={<Login />} />

        <Route path="/admin" element={<ProtectedRoute />}>
          <Route element={<AuthenticationForLogin />}>
            <Route element={<HeadAndSide />}>
              <Route path="dashboard" element={< Dashboard />} />
              <Route path="newrequest" element={<NewRequest />} />
              <Route path="usertrips" element={<UserTrips />} />
              {/* <Route path="tripdetails" element={<TripDetails />} /> */}
              <Route path="requestmanagement" element={<RequestManagement />} />
              <Route path="bookings" element={<Bookings />} />
              <Route path="add-carousel" element={<AddCarousel />} />
              <Route path="save-cabs" element={<SaveCabs />} />
              <Route path="requests" element={<Requests />} />
              <Route path="helpandsupport" element={<HelpAndSupport />} />
              <Route path="register-vendor" element={<RegisterVendor />} />
              {/* <Route path="userallquery" element={<UserAllQuery />} /> */}
              {/* <Route path="helpreply" element={<HelpReply />} /> */}
              <Route path="changepassword" element={<ChangePassword />} />
              <Route path="configuration-management" element={<ConfigurationManagement />} />
              <Route path='plan-management' element={<PlanManagement />} />
              <Route path='sms-campaign' element={<SMSCampaignManagement />} />
            </Route>
            <Route path='userallquery' element={<><Header /><UserAllQuery /></>} />
            <Route path='helpreply' element={<><Header /><HelpReply /></>} />
            <Route path='tripdetails' element={<><Header /><TripDetails /></>} />
            <Route path='vendorform' element={<><Header /><VendorForm /></>} />
            <Route path='add-cab' element={<><Header /><AddCab /></>} />
            <Route path='cab-details' element={<><Header /><CabDetails /></>} />
            <Route path='add-driver' element={<><Header /><AddDriver /></>} />
          </Route>
        </Route>

        {/* Redirect /admin to /admin/newrequest if logged in, otherwise to /login */}
        <Route path="/admin" element={isLoggedIn() ? <Navigate to="/admin/dashboard" replace /> : <Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
